var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('video-player',{ref:"videoPlayer",staticClass:"video-player-box",attrs:{"options":_vm.playerOptions,"playsinline":true,"autoplay":_vm.hasAutoplay}})
}
var staticRenderFns = []

export { render, staticRenderFns }